import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '../../../../modules/react/components/stateless/Button';
import CurrentPageContext from '../../../contexts/CurrentPageContext';
import ReviewModal from '../../../components/stateful/ReviewModal';
import SuccessModal from '../../../components/stateful/SuccessModal';

const propTypes = {
  facilityId: PropTypes.string,
  isSubmitting: PropTypes.bool,
  success: PropTypes.bool,
  review: PropTypes.shape({
    rating: PropTypes.number.isRequired,
  }),
  error: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  showReviewModal: PropTypes.bool,
  handleShowModal: PropTypes.func.isRequired,
  handleHideModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  children: PropTypes.node,
  isEditable: PropTypes.bool,
};

const defaultProps = {
  children: 'Write a Review',
  facilityId: undefined,
  isSubmitting: undefined,
  success: undefined,
  review: undefined,
  error: undefined,
  showReviewModal: undefined,
  isEditable: undefined,
};

class ReviewButton extends React.Component {
  static contextType = CurrentPageContext;

  handleSubmit = ({ facilityId, ...data }) => {
    const { handleSubmit } = this.props;

    return handleSubmit(facilityId, data);
  };

  handleCancel = () => {
    const { isSubmitting, handleHideModal } = this.props;

    if (!isSubmitting) {
      handleHideModal();
    }
  };

  handleClick = () => {
    const { handleShowModal, isEditable } = this.props;

    if (!isEditable) {
      handleShowModal();
    }
  };

  render() {
    const {
      facilityId,
      isSubmitting,
      success,
      review,
      error,
      showReviewModal,
      children,
    } = this.props;
    const { secondaryColorBackgroundClass,
      primaryColorBackgroundHoverClass,
      buttonStyleClass } = this.context;

    return (
      <div>
        <ReviewModal
          facilityId={facilityId}
          onSubmit={this.handleSubmit}
          onCancel={this.handleCancel}
          show={showReviewModal && !success}
          isSubmitting={isSubmitting}
          error={error}
        />
        <SuccessModal
          show={showReviewModal && success}
          onClose={this.handleCancel}
          review={review}
        />
        <Button
          block
          className={cx(secondaryColorBackgroundClass,
            primaryColorBackgroundHoverClass,
            buttonStyleClass)}
          onClick={this.handleClick}
          variant="primary"
        >
          {children}
        </Button>
      </div>
    );
  }
}

ReviewButton.propTypes = propTypes;
ReviewButton.defaultProps = defaultProps;

export default ReviewButton;
